import {Component, Input, OnInit} from '@angular/core';
import {DeviceWithUuidAndStatus} from '../../../afb-api/models/device';

@Component({
  selector: 'awair-floor-plan-editor-device-list',
  templateUrl: './floor-plan-editor-device-list.component.html',
  styleUrls: ['./floor-plan-editor-device-list.component.scss']
})

export class FloorPlanEditorDeviceListComponent implements OnInit {

  @Input() devicesWithUuidAndStatus: DeviceWithUuidAndStatus[] = [];

  constructor() {
  }

  ngOnInit() {
  }
}
